// useSupervisorNotifications.js
import { useEffect, useState } from 'react';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

export function useSupervisorNotifications(isAuthenticated, userRole) {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (!isAuthenticated || userRole !== 'SUPERVISOR') return;

        const rawUrl = process.env.REACT_APP_WS_URL;
        if (!rawUrl) {
            console.warn('REACT_APP_WS_URL no está configurado. WebSocket de notificaciones deshabilitado.');
            return;
        }
        // SockJS requires http:// or https:// — convert wss:// and ws:// if needed
        const socketUrl = rawUrl.replace(/^wss:\/\//, 'https://').replace(/^ws:\/\//, 'http://');

        const stompClient = new Client({
            webSocketFactory: () => new SockJS(socketUrl),
            debug: (str) => console.log(str),
            reconnectDelay: 5000
        });

        let subscription;

        stompClient.onConnect = () => {
            console.log('Conectado a WebSocket (supervisor)');
            subscription = stompClient.subscribe('/topic/supervisors', (message) => {
                if (message.body) setMessages((prev) => [...prev, message.body]);
            });
        };

        stompClient.activate();

        return () => {
            if (subscription) subscription.unsubscribe();
            stompClient.deactivate();
            console.log('Desconectado de WebSocket');
        };
    }, [isAuthenticated, userRole]);

    return messages;
}
